import OnSiteEvaluationsContainer from './OnSiteEvaluationsContainer.js';

export default OnSiteEvaluationsContainer;